export default __webpack_public_path__ + "static/404-2-8b45cfd1fc733244ce2a7bde4bd6320f.svg";